<template>
  <div>
    <v-row dense>
      <v-col cols="4">
        <select-branch-model
          v-model="idBranch"
          class="c-input-small"
          dense
          outlined
          hide-details
          label="Cơ sở"
          :disabled="!!item.id"
          :auto-select="true"
        ></select-branch-model>
      </v-col>
      <v-col cols="8">
        <input-qr-scan-model
          v-model="code"
          ref="codeRef"
          label="Quét mã tài sàn | mã vệ sinh"
          :disabled="!idBranch || (!!item.id && [30, 40].includes(item.status))"
          @keyupEnter="scanInput"
        ></input-qr-scan-model>
      </v-col>

      <v-col cols="12" v-if="item.id || isClean">
        <v-simple-table class="table-padding-2 table-h-36 mt-5">
          <template v-slot:default>
            <thead class="v-data-table-header">
              <tr>
                <th role="columnheader" colspan="2">
                  <span class="primary--text fs-14px">
                    {{ item.asset_type_name }}</span
                  >
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center">
                <td>Mã</td>
                <td>{{ item.name || "Vệ sinh" }}</td>
              </tr>
              <tr
                class="text-center"
                v-for="prepairType in prepairTypeByStatus"
                :key="`pt_${prepairType.id}`"
              >
                <td>{{ prepairType.name }}</td>
                <td>
                  <div class="d-flex align-center justify-center">
                    <v-checkbox
                      v-if="prepairType.type == 1"
                      v-model="selected"
                      class="mt-0 ml-1"
                      :value="prepairType.id"
                      hide-details
                      multiple
                      dense
                    ></v-checkbox>
                    <v-text-field
                      v-else-if="prepairType.type == 2"
                      v-model="inputVal[prepairType.id]"
                      class="c-input-small"
                      dense
                      outlined
                      hide-details
                      label="Vị trí"
                    ></v-text-field>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th colspan="2">
                  <v-btn
                    class="mt-3"
                    color="success"
                    small
                    block
                    :disabled="isDisabledBtn"
                    @click="finishProcessing"
                  >
                    {{ $t("Xác nhận") }}
                  </v-btn>
                </th>
              </tr>
            </tfoot>
          </template>
        </v-simple-table>
      </v-col>

      <v-col cols="12" v-else>
        <div class="fs-14px font-weight-medium purple--text mt-5">
          Danh sách chờ:
        </div>
        <WaitList :idBranch="idBranch" :key="idBranch" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { httpClient } from "@/libs/http";
import { ASSET_UID_STATUS, CLEAN_CODE } from "@/libs/const";

export default {
  name: "Index",
  components: {
    WaitList: () => import("@/components/prepair/WaitList"),
  },
  data: () => ({
    idBranch: null,
    item: {},
    code: null,
    isLoading: false,
    prepairTypes: [],
    selected: [],
    inputVal: {},
    isClean: false,
  }),
  computed: {
    prepairTypeByStatus() {
      if (
        [ASSET_UID_STATUS.WAIT_PREPAIR, ASSET_UID_STATUS.PREPARING].includes(
          this.item.status
        )
      ) {
        return [...this.prepairTypes].filter((pt) => !!pt.is_required);
      }

      return [...this.prepairTypes].filter((pt) => !pt.is_required);
    },
    isDisabledBtn() {
      if (this.item.status == ASSET_UID_STATUS.AVAILABLE) {
        return false;
      }

      const requiredUncheck = [...this.prepairTypes].filter(
        (pt) =>
          !!pt.is_required && pt.type == 1 && !this.selected.includes(pt.id)
      );
      const requiredInput = [...this.prepairTypes].filter(
        (pt) => !!pt.is_required && pt.type == 2 && !this.inputVal[pt.id]
      );

      return requiredUncheck.length > 0 || requiredInput.length > 0;
    },
  },
  mounted() {
    this.getProcessing();
  },
  methods: {
    onRest() {
      this.isLoading = false;
      this.isClean = false;
      this.item = {};
      this.prepairTypes = [];
      this.selected = [];
      this.inputVal = {};
    },
    async getPrepairType() {
      const { data } = await httpClient.post("/asset/v1/get-prepair-type", {
        id_asset_type: this.item.id_asset_type,
      });
      this.prepairTypes = [...data];
    },
    async getProcessing() {
      const { data } = await httpClient.post("/asset/v1/prepair-processing");
      if (data) {
        this.item = { ...data };
        this.idBranch = data.id_branch;
        this.getPrepairType();
      }
    },
    async finishProcessing() {
      if (this.isDisabledBtn && !this.isClean) {
        return false;
      }

      if (this.isLoading) {
        this.$vToastify.warning(this.$t("messages.loading"));
        return false;
      }
      this.isLoading = true;

      try {
        await httpClient.post("/asset/v1/prepair-finish", {
          id_asset_uid_prepair: this.item.id_asset_uid_prepair,
          selected: this.selected,
          input_values: this.inputVal,
          code: this.isClean ? CLEAN_CODE : null,
        });
        this.onRest();
      } catch (e) {
        this.isLoading = false;
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
      }
    },
    async scanInput() {
      if (!this.code) {
        return false;
      }

      const code = this.code.toUpperCase();

      if (this.item.id && code != CLEAN_CODE) {
        return false;
      }

      if (code == CLEAN_CODE) {
        this.isClean = true;
        this.code = null;
        document.getElementById("success_sound_player").play();
        if (this.item && this.item.id) {
          this.finishProcessing();
        }
        return false;
      }

      if (this.isLoading) {
        this.$vToastify.warning(this.$t("Loading"));
        return false;
      }

      this.isLoading = true;

      try {
        const { data } = await httpClient.post("/asset/v1/prepair-start", {
          code: code,
          id_branch: this.idBranch,
        });
        this.code = null;
        this.isLoading = false;

        this.item = { ...data };
        if (this.isClean) {
          this.finishProcessing();
        } else {
          this.getPrepairType();
        }
        document.getElementById("success_sound_player").play();
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
        this.code = null;
        this.isLoading = false;
        document.getElementById("error_sound_player").play();
      }
    },
  },
};
</script>
